import { useState } from "react";
import { Linkedin } from "lucide-react";

const BHUPINDER_IMG = "https://customer-assets.emergentagent.com/job_incred-wealth-sg/artifacts/ztrd3x0e_Bhupinder-Singh.jpg";
const SAURABH_IMG = "https://customer-assets.emergentagent.com/job_incred-wealth-sg/artifacts/n2mrkw2e_Saurabh-Jhalaria.jpg";
const TANUJ_IMG = "https://customer-assets.emergentagent.com/job_incred-wealth-sg/artifacts/ruk4jc4c_Tanuj%20Khosla.jpg";

const GIRISH_IMG = "https://customer-assets.emergentagent.com/job_incred-wealth-sg/artifacts/3vxi29xz_Girish%20Rathod.jpg";

const teamMembers = [
  {
    name: "Bhupinder Singh",
    title: "Founder & Group CEO, InCred Group",
    bio: "Bhupinder Singh brings over two decades of experience in financial services, with 10 years of experience in steering Indian businesses. He founded the InCred Group in 2016 with an aim to build a world-class diversified financial services company. Today InCred has a presence in Lending, Wealth Management, Asset Management, Investment Banking & Capital Markets, Equities Research & Broking to name a few. Prior to this, he was the head of the Corporate Finance division of Deutsche Bank and co-headed the Fixed Income, Equities and Investment Banking divisions for the Asia Pacific region.",
    image: BHUPINDER_IMG,
  },
  {
    name: "Saurabh Jhalaria",
    title: "CIO, Alternative Credit Strategies, InCred Asset Management",
    bio: "Saurabh has 20+ years of experience across the credit and financing business in Asia and has been part of the founding team at InCred Group since 2016. He is the CIO for alternative credit strategies for InCred Capital and also looks at the SME lending business at InCred Finance, the NBFC arm. Prior to joining InCred, Saurabh was a Managing Director at Deutsche Bank leading the private financing and performing credit business for India and South East Asia. He holds a PGDM from IIM Bangalore, is a CFA charterholder and has an undergraduate in commerce and accounting from St Xaviers College, Kolkata.",
    image: SAURABH_IMG,
  },
  {
    name: "Anup P Kurup",
    title: "CIO, InCred Global Asset Management",
    bio: null,
    bulletBio: [
      "20+ years of Buy side experience in Equity/Convertible bonds/Fixed Income/Credit Derivatives across UK, Singapore, Dubai",
      "Headed ICICI Bank UK Proprietary Investment Management Group overseeing a multi-asset Portfolio of USD 750 Million",
      "Co-managed a $450mn+ Convertible Bond portfolio & $1bn+ proprietary credit derivative portfolio for ICICI UK & Singapore",
      "Previously CIO for BanyanTree Asset Management & JM Financial Singapore",
      "PGDM from IIM Ahmedabad, B-Tech - Mechanical Engineering, CFA Charter holder & Certified FRM",
    ],
    image: null,
  },
  {
    name: "Tanuj Khosla, CFA",
    title: "Managing Director | Portfolio Manager | Head of Multi-Strategy Credit, InCred Global Asset Management",
    bio: "Tanuj Khosla is a multi-strategy credit investor with 14+ years of buy-side experience across APAC and the Middle East, spanning public and private markets. He has deployed capital across investment grade, high yield, distressed and special situations — in both hard and local currency — across 20+ jurisdictions, navigating complex cross-border capital structures in fragmented and structurally inefficient markets. His experience includes building and running credit books from inception, managing risk through cycles, and generating alpha in both emerging and developed credit ecosystems. Previously he ran EM Credit Proprietary Trading book at Louis Dreyfus Company. Prior to that he managed the Asia Credit pod inside the flagship multi-strategy fund of Dymon Asia Capital. He was ranked No. 1 in The Asset's \"Most Astute Investors in Asian G3 Bonds\" (2025), with prior recognition in 2022 and 2016. He holds both the CFA and CAIA Charters and is an MBA (Finance & Strategy) from Nanyang Business School.",
    image: TANUJ_IMG,
  },
  {
    name: "Bharat Gorsiya",
    title: "Portfolio Manager",
    bulletBio: [
      "18+ years of Buy side experience in trading & portfolio management of Equities & Convertible Bonds",
      "Portfolio manager for a USD 450mn+ Convertible Bond & equities portfolio within the Investment Management Group at ICICI UK",
      "Portfolio Manager for equity strategies at BanyanTree Asset Management & Alpha Quest Singapore",
      "B-Com from Mumbai University & CFA Charter holder",
    ],
    image: null,
  },
  {
    name: "Girish Rathor",
    title: "Head of Credit Research",
    bulletBio: [
      "Girish is a highly experienced professional with a 17-year career anchored by 14 years of dedicated focus on credit investing and an additional three years in credit ratings",
      "He has significant experience of investments across multiple credit cycles, with a specialized focus on performing credit and special situations",
      "His investment background includes extensive experience across the entire capital structure. This expertise is applied across a highly diversified, multi-sector portfolio.",
      "His prior stints include Lonestar Fund\u2019s NBFC, Edelweiss Alternatives, and ICRA Limited (Moody\u2019s India)",
      "Girish brings strong analytical fundamentals to his approach, holding a Post Graduate Diploma in Management from the Indian Institute of Management, Kozhikode, and a Bachelor\u2019s in Technology from the Indian Institute of Technology, Bombay",
    ],
    image: GIRISH_IMG,
  },
  {
    name: "Philipp Orgler",
    title: "Quantitative & Risk",
    bulletBio: [
      "24+ years experience in Financial Services across Deutsche Bank, Barclays Investment Bank & Mizuho",
      "Previously MD & Head Structuring, Japan for Barclays Investment Bank & Head of Structured MTNs & Repacks for Mizuho",
      "Was Director Interest rate structuring at Deutsche Bank and a Senior Strategist at Rokos Capital Management",
      "Post Graduate research in Mathematical Physics from the University of Tokyo, MS in Theoretical Physics from Karl-Franzens-Universit\u00e4t Graz & MSc Business Analytics from Imperial College, London",
    ],
    image: null,
  },
  {
    name: "Binal Shah",
    title: "Investment Research Analyst",
    bulletBio: [
      "8+ years of research experience as a Senior Equity Research Analyst at Guggenheim Partner\u2019s Transparent Value",
      "Covered Industrials, Agricultural Machinery, Aerospace and Defense",
      "PGDM from NL Dalmia Institute of Management",
    ],
    image: null,
  },
  {
    name: "Jeet Patel",
    title: "Investment Research Analyst",
    bulletBio: [
      "5+ years of Capital Markets experience between Buy-side Multi-Asset investment management and Sell-side Institutional Equity Research",
      "MS Finance from Rochester Institute of Technology, New York, B.E - Electronics & Telecommunication Engineering from Mumbai University",
    ],
    image: null,
  },
  {
    name: "Tushar Verma",
    title: "Quantitative Analyst",
    bulletBio: [
      "Worked as Quant Analyst for Rivercrest Power Trading focused on US Power Market and Gas Markets and as intern at DRDO and BEL",
      "MS - Quantitative Finance from Rutgers University, BTech - Electronics and Communications Engineering from MIT Manipal",
    ],
    image: null,
  },
];

const InitialsAvatar = ({ name }) => {
  const initials = name.split(" ").filter(w => w[0] && w[0] === w[0].toUpperCase() && w !== "CFA").slice(0, 2).map(w => w[0]).join("");
  return (
    <div className="w-full h-full bg-gradient-to-br from-[#4A6670] to-[#2E444D] flex items-center justify-center">
      <span className="text-5xl font-heading font-medium text-white/90 tracking-wider">{initials}</span>
    </div>
  );
};

const TeamCard = ({ member, idx }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div
      className="team-card group bg-white border border-slate-200 rounded-sm overflow-hidden hover:border-[#4A6670] transition-all duration-300 hover:-translate-y-1 hover:shadow-lg"
      data-testid={`team-card-${idx}`}
    >
      {/* Photo */}
      <div className="aspect-[3/4] overflow-hidden bg-slate-100 relative">
        {member.image ? (
          <img
            src={member.image}
            alt={member.name}
            className="team-card-img w-full h-full object-cover object-top"
            data-testid={`team-image-${idx}`}
          />
        ) : (
          <InitialsAvatar name={member.name} />
        )}
        {/* Subtle gradient overlay at bottom for text legibility */}
        <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-black/20 to-transparent" />
      </div>

      {/* Info */}
      <div className="p-6 relative">
        {/* Orange accent bar */}
        <div className="absolute top-0 left-6 right-6 h-[2px] bg-[#E87722] transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-500" />

        <h3 className="text-lg font-semibold text-slate-900 font-heading mt-1" data-testid={`team-name-${idx}`}>
          {member.name}
        </h3>
        <p className="text-xs font-medium text-[#E87722] mt-2 leading-relaxed uppercase tracking-wide font-body" data-testid={`team-title-${idx}`}>
          {member.title}
        </p>

        {member.bio && (
          <>
            <p
              className={`text-xs text-slate-500 mt-4 leading-relaxed font-body ${expanded ? "" : "line-clamp-3"}`}
              data-testid={`team-bio-${idx}`}
            >
              {member.bio}
            </p>
            <button
              onClick={() => setExpanded(!expanded)}
              className="text-xs font-medium text-[#4A6670] hover:text-[#E87722] mt-2 transition-colors duration-200"
              data-testid={`team-read-more-${idx}`}
            >
              {expanded ? "Show less" : "Read more"}
            </button>
          </>
        )}

        {member.bulletBio && (
          <>
            <ul
              className={`text-xs text-slate-500 mt-4 leading-relaxed font-body space-y-1.5 list-disc pl-4 ${expanded ? "" : "line-clamp-4"}`}
              data-testid={`team-bio-${idx}`}
            >
              {member.bulletBio.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
            <button
              onClick={() => setExpanded(!expanded)}
              className="text-xs font-medium text-[#4A6670] hover:text-[#E87722] mt-2 transition-colors duration-200"
              data-testid={`team-read-more-${idx}`}
            >
              {expanded ? "Show less" : "Read more"}
            </button>
          </>
        )}
      </div>
    </div>
  );
};

const OurTeam = () => {
  return (
    <section id="team" data-testid="team-section" className="py-24 sm:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section header */}
        <div className="mb-16 text-center">
          <p className="text-sm uppercase tracking-[0.2em] font-semibold text-[#4A6670] mb-4 font-body" data-testid="team-overline">
            Leadership
          </p>
          <h2 className="text-3xl sm:text-4xl tracking-tight font-medium text-slate-900 font-heading" data-testid="team-title">
            Investment Management Expertise Across the InCred Group
          </h2>
          <div className="w-16 h-[2px] bg-[#E87722] mx-auto mt-4" />
          <p className="mt-6 text-base text-slate-500 max-w-2xl mx-auto font-body" data-testid="team-subtitle">
            Seasoned professionals with decades of combined experience from leading global banks and financial institutions.
          </p>
        </div>

        {/* Team grid - 4 columns */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {teamMembers.map((member, idx) => (
            <TeamCard key={idx} member={member} idx={idx} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurTeam;
